// src/utils/authProviders.js
// 소셜 로그인 제공자 메타 + 국가별 우선순위.
// 버튼 색/라벨은 각 브랜드 가이드 기준. i18nKey 는 locales/*.json 의 키.

export const PROVIDER_META = {
  kakao:    { i18nKey: 'auth.kakaoLogin',    bg: '#FEE500', fg: '#191600' },
  facebook: { i18nKey: 'auth.facebookLogin', bg: '#1877F2', fg: '#FFFFFF' },
  line:     { i18nKey: 'auth.lineLogin',     bg: '#06C755', fg: '#FFFFFF' },
  google:   { i18nKey: 'auth.googleLogin',   bg: '#FFFFFF', fg: '#1F1F1F', border: true },
  apple:    { i18nKey: 'auth.appleLogin',    bg: '#000000', fg: '#FFFFFF' },
};

// 국가별 주력 메신저 — 인앱 브라우저에서도 정상 작동하는 1순위 버튼.
export const PRIMARY_BY_COUNTRY = { KR: 'kakao', US: 'facebook', JP: 'line' };

// Firebase 콘솔에 실제로 등록·활성화된 제공자만 노출한다.
// (미등록 제공자 버튼은 클릭 시 에러나므로 여기에 넣지 않는다.)
// → LINE/Facebook/Google/Apple 설정이 끝나면 이 배열에 키를 추가하면 즉시 노출됨.
export const ENABLED_PROVIDERS = ['kakao', 'google', 'line'];

// 표시 순서: [국가 1순위, google, apple, 나머지 지역 제공자] 중 활성화된 것만.
export function providerOrder(country) {
  const primary = PRIMARY_BY_COUNTRY[country] || 'kakao';
  const regionals = ['kakao', 'facebook', 'line'];
  const ordered = [primary, 'google', 'apple', ...regionals.filter((p) => p !== primary)];
  return ordered.filter((p, i) => ordered.indexOf(p) === i && ENABLED_PROVIDERS.includes(p));
}
